module.exports = __webpack_public_path__ + "img/bnr.c0800d4a.jpg";